module.exports = __webpack_public_path__ + "img/pickup.ecd2377b.png";